// extracted by mini-css-extract-plugin
export var layoutContainer = "_f-0";
export var layoutContainerNoRounding = "_f-6";
export var layoutContainerOpen = "_f-5";
export var layoutContainerResizing = "_f-1";
export var mainContent = "_f-2";
export var resizeDivider = "_f-3";
export var slidePanel = "_f-4";